(() => {
  const wrapperSelector = '[id^="Avada_SalesPopV2--"]';
  const timeSelector = '.Avada-SaleNotificationV2__TimeAgo';
  const campaigns = new Map();

  const captureCampaigns = () => {
    if (!Array.isArray(window.AVADA_SP_V2) || !window.AVADA_SP_V2.length) return false;

    window.AVADA_SP_V2.forEach((campaign) => campaigns.set(campaign.id, campaign));
    return true;
  };
  const unitForms = {
    second: ['sekundę', 'sekundy', 'sekund'],
    minute: ['minutę', 'minuty', 'minut'],
    hour: ['godzinę', 'godziny', 'godzin'],
    day: ['dzień', 'dni', 'dni'],
    week: ['tydzień', 'tygodnie', 'tygodni'],
    month: ['miesiąc', 'miesiące', 'miesięcy'],
    year: ['rok', 'lata', 'lat'],
  };

  const polishUnit = (value, unit) => {
    const forms = unitForms[unit];
    const lastDigit = value % 10;
    const lastTwoDigits = value % 100;
    const usesFewForm = lastDigit >= 2 && lastDigit <= 4 && !(lastTwoDigits >= 12 && lastTwoDigits <= 14);

    if (value === 1) return forms[0];
    return usesFewForm ? forms[1] : forms[2];
  };

  const formatElapsedTime = (date) => {
    const elapsedSeconds = Math.max(0, Math.floor((Date.now() - new Date(date).getTime()) / 1000));
    if (!Number.isFinite(elapsedSeconds)) return '';
    if (elapsedSeconds < 60) return 'kilka sekund temu';

    const units = [
      ['year', 31536000],
      ['month', 2592000],
      ['week', 604800],
      ['day', 86400],
      ['hour', 3600],
      ['minute', 60],
    ];
    const [unit, seconds] = units.find(([, unitSeconds]) => elapsedSeconds >= unitSeconds);
    const value = Math.floor(elapsedSeconds / seconds);

    return `${value} ${polishUnit(value, unit)} temu`;
  };

  const translateTime = (element) => {
    const text = element.textContent.trim();

    if (/^few seconds ago$/i.test(text)) {
      element.textContent = 'kilka sekund temu';
      return;
    }

    const match = text.match(/^(\d+)\s+(second|minute|hour|day|week|month|year)s?\s+ago$/i);
    if (!match) return;

    const value = Number(match[1]);
    const unit = match[2].toLowerCase();
    element.textContent = `${value} ${polishUnit(value, unit)} temu`;
  };

  const restoreMissingTime = (wrapper) => {
    const campaignId = wrapper.id.replace('Avada_SalesPopV2--', '');
    const campaign = campaigns.get(campaignId);
    const content = wrapper.querySelector('.Avada_SaleNotificationV2--WrapperContent');
    if (!campaign || !content || content.querySelector(timeSelector) || campaign.hide_time_ago) return;

    const firstName = (content.querySelector('.Avada-SaleNotificationV2__Address')?.textContent || '')
      .split(' właśnie')[0]
      .trim();
    const productName = (content.querySelector('.Avada-SaleNotificationV2__ProductName')?.textContent || '')
      .replace(/\.\.\.$/, '')
      .trim();
    const notification = (campaign.notifications || []).find(
      (item) => item.first_name === firstName && (item.product_name || '').startsWith(productName),
    );
    const translatedTime = notification ? formatElapsedTime(notification.date) : '';
    if (!translatedTime) return;

    const element = document.createElement('div');
    element.className = timeSelector.slice(1);
    element.style.color = campaign.timeColor || '#ffffff';
    element.textContent = translatedTime;
    content.appendChild(element);
  };

  const translateSalesPopTimes = () => {
    document.querySelectorAll(wrapperSelector).forEach((wrapper) => {
      const time = wrapper.querySelector(timeSelector);
      if (time) translateTime(time);
      else restoreMissingTime(wrapper);
    });
  };

  const observer = new MutationObserver(translateSalesPopTimes);
  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true,
  });

  let attempts = 0;
  const captureTimer = window.setInterval(() => {
    attempts += 1;
    if (captureCampaigns() || attempts >= 500) {
      window.clearInterval(captureTimer);
      translateSalesPopTimes();
    }
  }, 10);

  captureCampaigns();
  translateSalesPopTimes();
})();
